import { Circle, Fill, Stroke, Style, Text } from 'ol/style';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import 'ol/ol.css';
import * as olColor from 'ol/color';
import GeoJSON from 'ol/format/GeoJSON';

export default class NoFlightZone{
    constructor(){
        this.styleNoFlightZone = function(feature, resolution) {

            if( feature.getProperties()._level_id == 5 ){ //おすすめ
                return
            }
        
            if( feature.getProperties()._level_id == 0 && feature.getGeometry().getType() == 'Point'){ //飛行場の外周
                return
            }
        
            if( feature.getProperties()._level_id == 3 && feature.getGeometry().getType() == 'Point'){ //飛行場の外周
                return
            }
        
        
            var text = new Style({
                text :new Text({
                    text: feature.getProperties().name,
                    font: '14px Calibri,sans-serif',
                    weight:'Bold',
                    fill: new Fill({ color: '#000' }),
                    stroke: new Stroke({
                        color: feature.getProperties()._color, width: 10
                    }),
                    offsetX: 30,
                    offsetY: -25,
                    rotation: 0
                })
            });
        
            const [r, g, b] = Array.from(olColor.asArray(feature.getProperties()._color));
            var styleZone = null;
            if (feature.getGeometry().getType() == 'Point') {
        
                styleZone = new Style({
                    image: new Circle({
                        radius: feature.getProperties()._radius / (resolution / 1.4), //TODO.正式な計算方法ではない。やや広め
                        stroke: new Stroke({
                          color: olColor.asString([r, g, b, 1.0])
                        }),
                        fill: new Fill({
                          color: olColor.asString([r, g, b, 0.3])
                        })
                    })
                });
        
            }else{
            
                styleZone = new Style({
                    stroke: new Stroke({ 
                      color: olColor.asString([r, g, b, 1.0])
                    }),
                    fill: new Fill({
                      color: olColor.asString([r, g, b, 0.3])
                    })
                });
            }
            
            return [styleZone, text]
        };

        this.vectorSource = new VectorSource({
            url: "https://afedrone-p-jp-s3-file-server.s3.ap-northeast-1.amazonaws.com/assets/NoFlightZone.geojson",
            format: new GeoJSON()
        });
        this.layerNoFlightZone = new VectorLayer({
            id: 'noFlightZone',
            zIndex: 3,
            source: this.vectorSource,
            style: this.styleNoFlightZone
        });
    }
        
}

